import React from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useSelector } from 'react-redux';
import Fill from './Fill';
import { selectNormalizedInterval } from '../../../selectors';

function AdPoints(props) {
  const {
    disabled,
    adsPointsOffset = [],
    width,
  } = props;
  const [, , duration] = useSelector(selectNormalizedInterval, shallowEqual);

  const hasPosroll = adsPointsOffset.filter(offset => offset === -1).length;
  const adsPoints = [
    ...adsPointsOffset.filter(offset => offset >= 0 && offset < duration),
    ...hasPosroll ? [duration] : [],
  ];

  if (!adsPoints.length || disabled) return null;

  return (
    <>
      {adsPoints.map(offset => (
        <Fill
          key={offset}
          color="ads"
          left={`${(offset / duration) * 100}%`}
          width={`${width}px`}
        />
      ))}
    </>
  );
}

AdPoints.propTypes = {
  disabled: PropTypes.bool.isRequired,
  adsPointsOffset: PropTypes.arrayOf(PropTypes.number),
  width: PropTypes.number.isRequired,
};

export default React.memo(AdPoints);
